module.exports = __webpack_public_path__ + "static/media/logo.aba1bda0.png";